export const MESSAGE_ENDPOINT = "/email";
